export default class Accordeon {
    constructor(element) {
        this.element = element;
        this.groups = this.element.querySelectorAll('.accordeon-group');
        this.init();
    }

    init() {
        this.groups.forEach(group => {
            const title = group.querySelector('.accordeon-title');
            const content = group.querySelector('.accordeon-content');

            if (!title || !content) {
                return;
            }

            title.addEventListener('click', (event) => {
                event.stopPropagation();

                const isOpen = group.classList.contains('open');
                const siblingGroups = [...group.parentElement.children].filter(child => child.classList.contains('accordeon-group'));

                siblingGroups.forEach(g => {
                    g.classList.remove('open');
                    const c = g.querySelector('.accordeon-content');
                    if (c) c.style.maxHeight = null;
                });

                if (!isOpen) {
                    group.classList.add('open');
                    if (content) {
                        content.style.maxHeight = content.scrollHeight + "px";
                    }
                }

                this.updateParentHeights(group);
            });
        });
    }

    updateParentHeights(group) {
        let parentContent = group.parentElement.closest('.accordeon-content');

        while (parentContent) {
            const parentGroup = parentContent.closest('.accordeon-group');

            if (parentGroup && parentGroup.classList.contains('open')) {
                parentContent.style.maxHeight = parentContent.scrollHeight + "px";
            }

            parentContent = parentGroup?.parentElement.closest('.accordeon-content');
        }
    }
}
